import { watch } from 'vue'

/**
 * Composable pour gérer les watchers de QuoteDetailPage
 * Limite: 40 lignes max
 */
export function useQuoteDetailPageWatchers(editedQuote, isEditing, selectedSession) {
  watch(() => editedQuote.value.inter_session_id, (newVal) => {
    if (selectedSession.value) {
      editedQuote.value.inter_tarif = selectedSession.value.tarif
    } else {
      editedQuote.value.inter_tarif = null
    }
  })

  watch(() => editedQuote.value.dates_inconnues, (value) => {
    if (value && isEditing.value) {
      editedQuote.value.dates_disponibilites = []
      editedQuote.value.dates_periodes = []
    }
  })
}
